import { green, red, yellow, blue, purple, grey, orange } from "@mui/material/colors";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import * as DefaultRoutes from "@Routes/DefaultRoutes";
import GenericHomePage from "../GenericHomePage/GenericHomePage";
import FolderCopyRoundedIcon from '@mui/icons-material/FolderCopyRounded';
import CreateNewFolderRoundedIcon from '@mui/icons-material/CreateNewFolderRounded';
import ContactMailRoundedIcon from '@mui/icons-material/ContactMailRounded';
import MailRoundedIcon from '@mui/icons-material/MailRounded';
import MarkEmailUnreadRoundedIcon from '@mui/icons-material/MarkEmailUnreadRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import FlagRoundedIcon from '@mui/icons-material/FlagRounded';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

const ApproverHome = () => {
  const navigate = useNavigate();

  const theme = useTheme();
  let sectionsBox = [
    // Plans to Approve - hidden: exit plans no longer require approval.
    // Uncomment to restore when needed again.
    // {
    //   textBeside: "Plans to Approve",
    //   icon: FactCheckRoundedIcon,
    //   iconColor: blue[700],
    //   iconFontSize: theme.spacing(10),
    //   boxbackgroundColor: blue[100],
    //   onClick: () => navigate(DefaultRoutes.ApproverPlansToApprove),
    // },
    {
      textBeside: "Exemptions to Approve",
      icon: FactCheckRoundedIcon,
      iconColor: blue[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: blue[100],
      onClick: () => navigate(DefaultRoutes.ApproverExemptionsToApprove),
    },
    {
      textBeside: "Regulatory Exemptions Hub",
      icon: ReceiptLongIcon,
      iconColor: orange[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: orange[100],
      onClick: () => navigate(DefaultRoutes.ApproverExemptionsHub),
    },
    // Pending Approvals - hidden for a simpler, plan-first approval flow.
    // Uncomment to restore when needed again.
    // {
    //   textBeside: "Pending Approvals",
    //   icon: MarkEmailUnreadRoundedIcon,
    //   iconColor: purple[700],
    //   iconFontSize: theme.spacing(10),
    //   boxbackgroundColor: purple[100],
    //   onClick: () => navigate(DefaultRoutes.PendingApprovals),
    // },
    {
      textBeside: "Escalated Requests",
      icon: FlagRoundedIcon,
      iconColor: orange[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: orange[100],
      onClick: () => navigate(DefaultRoutes.ApproverEscalatedRequests),
    },
    {
      textBeside: "My Approvals History",
      icon: ContactMailRoundedIcon,
      iconColor: green[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: green[100],
      onClick: () => navigate(DefaultRoutes.AssignedRequests),
    },
    {
      textBeside: "Regulatory Ingredients Hub",
      icon: MailRoundedIcon,
      iconColor: green[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: green[100],
      onClick: () => navigate(DefaultRoutes.AllExitRequests),
    },
  ];
  return <GenericHomePage sectionsBox={sectionsBox} />;
};
export default ApproverHome;
